import { render, staticRenderFns } from "./AddDiscount.vue?vue&type=template&id=df5ac148&scoped=true"
import script from "./AddDiscount.vue?vue&type=script&lang=js"
export * from "./AddDiscount.vue?vue&type=script&lang=js"
import style0 from "./AddDiscount.vue?vue&type=style&index=0&id=df5ac148&prod&scoped=true&lang=css"
import style1 from "./AddDiscount.vue?vue&type=style&index=1&id=df5ac148&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5ac148",
  null
  
)

export default component.exports